import { IGetDeepLinkRequest, IDeepLink } from '@gem/models/deeplinksModel';
import { logger } from '@gem/modules/logger';

import { mapB2bDeepLinkResponse } from 'APP/model/deeplinks/deeplinksModel.b2b.mapper';
import {
  createMessageDeepLinkRequest,
  getDeepLinkRequest,
} from 'APP/wsApi/wsAppApi/requests/deeplinkRequests';

import { buildModelError } from '../error/errorBuilder';

export const getDeepLink = async (data: IGetDeepLinkRequest): Promise<IDeepLink> => {
  try {
    const response = await getDeepLinkRequest(data);

    if (response.type.case === 'success') {
      return mapB2bDeepLinkResponse(response.type.value.deepLinkData!);
    } else {
      throw response.type.value;
    }
  } catch (error) {
    logger.get('API').error('deeplinks.getDeepLink', error);
    throw buildModelError(error);
  }
};

export const createMessageDeepLink = async (data: {
  groupId: string;
  messageId: string;
}): Promise<{ deepLink: string }> => {
  try {
    const response = await createMessageDeepLinkRequest({
      chatId: BigInt(data.groupId),
      messageId: BigInt(data.messageId),
    });

    if (response.type.case === 'success') {
      return response.type.value;
    } else {
      throw response.type.value;
    }
  } catch (error) {
    logger.get('API').error('deeplinks.createMessageDeepLink', error);
    throw buildModelError(error);
  }
};
